<section class="my-news">
  <app-my-carousel-swiper [config]="carouselOptions">
    @if(loading){
    <div class="swiper-slide" *ngFor="let item of [1, 1, 1, 1]">
      <div class="card-skeleton">
        <div class="image-placeholder"></div>
        <div class="content-placeholder">
          <div class="desc-placeholder" style="width: 20%;"></div>
          <div class="title-placeholder"></div>
          <div class="desc-placeholder" style="width: 95%;"></div>
          <div class="desc-placeholder" style="width: 90%;"></div>
        </div>
      </div>
    </div>
    } @else { @for(i of banners.data; track i){
    <div class="swiper-slide">
      <div class="my-card">
        <img loading="lazy" src="{{ imgUrl + i.image }}" alt="..." (error)="commonService.handleError($event)" [routerLink]="'/news/' + i.slug" />
        <div class="my-card__body">
          <div class="my-card__body--meta">{{ i.category }}</div>
          <!-- (click)="bottomBanner.openDetailBlog(detailBlog, i)" -->
          <h4 class="my-card__body--title" [routerLink]="'/news/' + i.slug">
            {{ i.title }}
          </h4>
          <div class="my-card__body--details">
            <div class="item">
              <i class="fa fa-clock"></i>
              <span>{{ convertDate(i.created) }}</span>
            </div>
            <div class="item">
              <i class="fa fa-user"></i>
              <span>
                {{ i.author }}
              </span>
            </div>
            <!-- <div class="item">
              <i class="fa fa-heart"></i>
              <span>{{ i.bottomBannerLikes?.length }}</span>
            </div> -->
          </div>
          <div class="text-right mr-3">
            <button *ngIf="adminMode" (click)="assign(i)">Assign</button>
          </div>
        </div>
      </div>
    </div>
    } @empty {
    <div class="no-product">
      <div class="no-product__title">You don't have News in your region</div>
      <button class="my-button-3" routerLink="/news">Add New</button>
    </div>
    } }
  </app-my-carousel-swiper>
</section>

<ng-template #AssignOption let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Assign Article</h4>
    <a (click)="modal.dismiss('Cross click')"><i class="fa fa-window-close" aria-hidden="true"></i></a>
  </div>
  <div class="modal-body">
    <section>
      <div>Category :</div>
      <div class="my-4 row d-flex justify-content-center">
        <ng-container *ngFor="let c of categoriesList">
          <span class="sub-cate p-2 m-2"> <input type="checkbox" [(ngModel)]="c.checked" /> {{ c.name }}</span>
        </ng-container>
      </div>
    </section>

    <section>
      <div>Sub Region :</div>
      <div class="my-4 row d-flex justify-content-center">
        <ng-container *ngFor="let s of subRegionList">
          <span class="sub-cate p-2 m-2"> <input type="checkbox" [(ngModel)]="s.checked" /> {{ s.name }}</span>
        </ng-container>
      </div>
    </section>

    <duv class="d-flex justify-content-end">
      <button type="button" class="btn btn-secondary" (click)="assignArticles()">Assign</button>
    </duv>
  </div>
</ng-template>
